import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  // Memoize the navigation state so we don't pass a new object reference on
  // every render of ProtectedRoute.
  const fromState = useMemo(() => ({ from: location }), [location]);

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f7f9fb]">
        <div className="text-slate-400 text-sm font-mono">Loading…</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={fromState} />;
  }
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
